import { Label } from "../../atoms/RTCC/label";

export const PullDownOptionForm = (props) => {
    const { divStyle, labelStyle, title, style, data, state, onChange } = props;
    return (
        <div className={props.wrapClassName}>
            <Label className={props.labelClassName} label={title} />
            <select style={style} onChange={onChange} value={state} className={props.className} id={props.id} tabIndex={props.tabIndex}>
                {data.map((value, index) => (<option key={index} value={value.id} >{value.value}</option>))}
            </select>
        </div>
    );
};